const CHUNK_RELOAD_KEY = "ecsf-chunk-reload-at";
const CHUNK_RELOAD_DEBOUNCE_MS = 30_000;

export const isChunkLoadError = (error: unknown): boolean => {
    if (!error) return false;
    const message =
        error instanceof Error
            ? error.message
            : typeof error === "string"
              ? error
              : "";
    return (
        message.includes("Failed to fetch dynamically imported module") ||
        message.includes("error loading dynamically imported module") ||
        message.includes("Importing a module script failed") ||
        message.includes("ChunkLoadError") ||
        message.includes("NS_ERROR_CORRUPTED_CONTENT") ||
        message.includes("Load failed") ||
        message.includes("does not provide an export named") ||
        message.includes("doesn't provide an export named") ||
        message.includes("Importing binding name")
    );
};

// Guards against a reload loop when the chunk is genuinely gone rather than
// just stale: after one reload we show the error instead of trying again.
export const shouldReloadForStaleChunks = (): boolean => {
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0);
    return Date.now() - last >= CHUNK_RELOAD_DEBOUNCE_MS;
};

export const reloadOnceForStaleChunks = (): void => {
    if (!shouldReloadForStaleChunks()) {
        return;
    }
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    window.location.reload();
};
